import imgCinema from '@loyal_images/brand/cards-benefits/imagem_cinema.png'
import imgTeatro from '@loyal_images/brand/cards-benefits/imagem_teatro.png'
import DrogariaSP from '@loyal_images/brand/cards-benefits/img_drogaria_sp.png'
import Evino from '@loyal_images/brand/cards-benefits/img_evino.png'
import LivUp from '@loyal_images/brand/cards-benefits/img_livup.png'
import Reserva from '@loyal_images/brand/cards-benefits/img_reserva.png'
import '@loyal_template/benefits.css'
import {
  CardBenefitsSpecial,
  CardBenefitsSpecialMobile, CardBenefitsTop,
  CardBenefitsTopMobile
} from 'loyal-react'
import React, { Component, Fragment } from 'react'
import MediaQuery from 'react-responsive'
import { Link } from 'react-router-dom'
import { ShowcaseBenefits } from '../../Showcase'
import { DiscountSuggestion } from '../DiscountSuggestion'

class ItauCardLanding extends Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  render () {
    return (
      <Fragment>
        <Link
          className='container-fluid pt-1 pt-md-0 bg-ui-3 benefits-banner-new'
          to='/benefits/listing'
          title='vai para lista de benefícios'
        />
        <div className='container-fluid px-0 bg-white d-flex justify-content-center discount-accordion'>
          <div className='container row px-0 pt-3'>
            <div className='row mx-0 px-0'>
              <div className='col-12 col-md-6 row mx-0 px-0 px-md-1 d-flex justify-content-center'>
                <Link
                  to='/benefits/listing'
                  className='bg-benefits-new mx-0 py-5 pl-3 pl-md-5 radius'
                  title='vai para lista de benefícios'
                />
              </div>
              <div className='col-12 col-md-6 mx-0 px-0 px-md-1'>
                <div className='row mx-0 pointer-beneficos'>
                  <MediaQuery maxDeviceWidth={425}>
                    <CardBenefitsTopMobile
                      link='https://www.reserva.ink/iupp'
                      title='Vai para Reserva'
                      alt='Reserva'
                      titleImg='Imagem Reserva'
                      image={Reserva}
                      description='Camisetas personalizadas iupp'
                    />
                    <CardBenefitsTopMobile
                      link='https://www.itau.com.br/content/dam/itau/cartoes/beneficios/PDF_Beneficio_Farmacia.pdf'
                      title='Vai para Drogaria São Paulo'
                      alt='Drogaria São Paulo'
                      titleImg='Imagem Drogaria São Paulo'
                      image={DrogariaSP}
                      description='Até 35% off'
                    />
                    <CardBenefitsTopMobile
                      link='https://www.livup.com.br/nosso-cardapio?utm_source=projetos&utm_medium=empresas&utm_campaign=itau'
                      title='Vai para Livup, nosso cardápio'
                      alt='Livup, nosso cardápio'
                      titleImg='Imagem Livup, nosso cardápio'
                      image={LivUp}
                      description='10% off com o cupom IUPP 10'
                    />
                    <CardBenefitsTopMobile
                      link='https://www.evino.com.br'
                      title='Vai para Evino'
                      alt='Evino'
                      titleImg='Imagem Evino'
                      image={Evino}
                      description='10% off com o cupom 10iupp'
                    />
                  </MediaQuery>
                  <MediaQuery minDeviceWidth={426}>
                    <CardBenefitsTop
                      link='https://www.reserva.ink/iupp'
                      title='Vai para Reserva'
                      alt='Reserva'
                      titleImg='Imagem Reserva'
                      image={Reserva}
                      description='Camisetas personalizadas iupp'
                    />
                    <CardBenefitsTop
                      link='https://www.itau.com.br/content/dam/itau/cartoes/beneficios/PDF_Beneficio_Farmacia.pdf'
                      title='Vai para Drogaria São Paulo'
                      alt='Drogaria São Paulo'
                      titleImg='Imagem Drogaria São Paulo'
                      image={DrogariaSP}
                      description='Até 35% off'
                    />
                    <CardBenefitsTop
                      link='https://www.livup.com.br/nosso-cardapio?utm_source=projetos&utm_medium=empresas&utm_campaign=itau'
                      title='Vai para Livup, nosso cardápio'
                      alt='Livup, nosso cardápio'
                      titleImg='Imagem Livup, nosso cardápio'
                      image={LivUp}
                      description='10% off com o cupom IUPP 10'
                    />
                    <CardBenefitsTop
                      link='https://www.evino.com.br'
                      title='Vai para Evino'
                      alt='Evino'
                      titleImg='Imagem Evino'
                      image={Evino}
                      description='10% off com o cupom 10iupp'
                    />
                  </MediaQuery>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='container-fluid bg-white px-0 d-flex justify-content-center discount-options'>
          <div className='container row px-0 pb-3'>
            <div className='col-12 discount-options-title'>
              <h2
                className='txt-font-title color-title px-1 px-md-0 py-2 py-md-0 d-block d-md-none'
                tabIndex={0}
              >
                Veja uma seleção de benefícios especiais para você.
              </h2>
              <h2
                className='txt-font-title color-title px-1 px-md-0 d-none d-md-block'
                tabIndex={0}
              >
                Veja uma seleção de benefícios especiais para você.
              </h2>
            </div>

            <MediaQuery maxDeviceWidth={425}>
              <CardBenefitsSpecialMobile
                link='https://www.itau.com.br/cartoes/beneficios/cinema/'
                title='Vai para Cinema'
                image={imgCinema}
                titleImg='Imagem Cinema'
                name='Cinema'
                description='50% de desconto'
              />
              <CardBenefitsSpecialMobile
                link='https://www.itau.com.br/cartoes/beneficios/teatro/'
                title='Vai para teatro'
                image={imgTeatro}
                titleImg='Imagem Teatro'
                name='Teatro'
                description='Até 50% de desconto'
              />
            </MediaQuery>
            <MediaQuery minDeviceWidth={426}>
              <CardBenefitsSpecial
                link='https://www.itau.com.br/cartoes/beneficios/cinema/'
                title='Vai para Cinema'
                image={imgCinema}
                titleImg='Imagem Cinema'
                name='Cinema'
                description='50% de desconto'
              />
              <CardBenefitsSpecial
                link='https://www.itau.com.br/cartoes/beneficios/teatro/'
                title='Vai para teatro'
                image={imgTeatro}
                titleImg='Imagem Teatro'
                name='Teatro'
                description='Até 50% de desconto'
              />
            </MediaQuery>
          </div>
        </div>
        <div className='container-fluid px-0 d-flex justify-content-center exclusive-discounts'>
          <ShowcaseBenefits
            title='Confira nossas promoções e descontos exclusivos.'
            titleMobile='Descontos exclusivos'
            searchPage='/benefits/listing'
          >
            <DiscountSuggestion />
          </ShowcaseBenefits>
        </div>
      </Fragment>
    )
  }
}

export default ItauCardLanding



// WEBPACK FOOTER //
// ./src/features/Benefits/Landing/ItauCardLanding.js